exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* Primary Colors */\n\n/* Greys/Secondary Colors */\n\n/* Status Colors */\n\n/* Same as above, camel case for js import */\n\n/* Graph Colors */\n\n/* KardiaRx EKG Time Series Graph */\n\n/* Table Colors */ /* #979797 at opacity 21% */\n\n/* ----- COLORS TO DEPRECATE ----- */\n\n/* Whites (Greys but let's call it white) */\n/*@value dark-white #CCCCCC;*/\n/*@value darker-white #999999;*/ /* white darken 40% - active */\n\n/* Greys */\n/*@value grey-1 #F1F5F3;*/ /* Medium Grey */ /* Dark Grey */\n/*@value grey-4 #EFEFEF;*/\n/*@value grey-5 #878787;*/\n\n/*@value lightest-grey #F7F6F3;*/\n/*@value lighter-grey #EAE9E8;*/\n/*@value light-grey #D1D0CF;*/\n\n/* Blues */\n/*@value light-blue #70D9FF;*/\n\n/* EKG analysis result colors */\n", ""]);

// exports
exports.locals = {
	"teal": "#2D9F86",
	"light-teal": "#6BC1B6",
	"light-teal-50": "rgba(107, 193, 182, 0.5)",
	"lighter-teal": "#DCF0EE",
	"lighter-teal-30": "rgba(220, 240, 238, .3)",
	"lightest-teal": "#EDF7F6",
	"black": "#212121",
	"silver": "#878787",
	"kardia-red": "#F15757",
	"bg-white": "#F2F4F8",
	"white": "#FFFFFF",
	"dark-white": "#FAFAFA",
	"lightest-grey": "#F2F2F2",
	"lighter-grey": "#EFEFEF",
	"light-grey": "#DCDCDC",
	"medium-grey": "#C2C2C2",
	"darker-grey": "#666666",
	"light-blue": "#DDEFEE",
	"slate-grey": "#6B7897",
	"unprescribed-grey": "#b0bec5",
	"dashboard-blue": "#4a90e2",
	"forgot-pass-blue": "#5e77ff",
	"kardia-green": "#6BC077",
	"kardia-yellow": "#FDC246",
	"kardia-orange": "#F78C4E",
	"kardia-grey": "#BABFBD",
	"kardia-red-crisis": "#B53835",
	"kardiaGreen": "#6BC077",
	"kardiaYellow": "#FDC246",
	"kardiaOrange": "#F78C4E",
	"kardiaGrey": "#BABFBD",
	"unprescribedGrey": "#b0bec5",
	"kardiaBlue": "#142A39",
	"gridRed": "#AE1E08",
	"waveformBlack": "#3D2525",
	"kardiaRx-blue": "#9DD3DE",
	"kardiaRx-red": "#CC3D3F",
	"tableGridGrey": "#E9E9E9",
	"tableGridRow": "#F6F9FB",
	"tableConfirmedColor": "#4BB543",
	"popoverBorder": "#F4F4F4",
	"popoverShadow": "rgb(52, 65, 82, 0.18)",
	"esignRed": "#db5305",
	"grey-2": "#BABFBD",
	"grey-3": "#536062",
	"dark-grey": "#9E9C9C",
	"kardia-black": "#242828",
	"grey40": "rgba(209, 208, 207, 0.4)",
	"placeholderGrey": "#757575",
	"lighter-blue": "#D6F3FF",
	"kardia-blue": "#00ABE8",
	"dark-blue": "#00698F",
	"darker-blue": "#004B66",
	"unclassified": "#FDC946",
	"light": "#EAE9E8"
};


//////////////////
// WEBPACK FOOTER
// /Users/travis/build/alivecor/kardia-pro/node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!/Users/travis/build/alivecor/kardia-pro/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/legacy/styles/variables/colors.css
// module id = 2
// module chunks = 23